import { lazy } from "react"

const Permission = lazy(() => import("../../pages/Permission"))
const PermissionDetail = lazy(() => import("../../pages/Permission/PermissionDetail"))
const Dashboard = lazy(() => import("../../pages/ees/Dashboard"))
const ProjectsPage = lazy(() => import("../../pages/ees/ProjectsPage"))
const ProjectDetailPage = lazy(() => import("../../pages/ees/ProjectDetailPage"))
const ProjectsMapPage = lazy(() => import("../../pages/ees/ProjectsMapPage"))
const DailyLogsPage = lazy(() => import("../../pages/ees/DailyLogsPage"))
const WaterResultsPage = lazy(() => import("../../pages/ees/WaterResultsPage"))
const AmmPage = lazy(() => import("../../pages/ees/AmmPage"))
const AmmEquipmentPage = lazy(() => import("../../pages/ees/amm/AmmEquipmentPage"))
const AmmStockPage = lazy(() => import("../../pages/ees/amm/AmmStockPage"))
const AmmProjectStockPage = lazy(() => import("../../pages/ees/amm/AmmProjectStockPage"))
const AmmStocktakePage = lazy(() => import("../../pages/ees/amm/AmmStocktakePage"))
const AmmIssuePage = lazy(() => import("../../pages/ees/amm/AmmIssuePage"))
const AmmMaintenancePage = lazy(() => import("../../pages/ees/amm/AmmMaintenancePage"))
const AmmSettingsPage = lazy(() => import("../../pages/ees/amm/AmmSettingsPage"))
const AmmReportsPage = lazy(() => import("../../pages/ees/amm/AmmReportsPage"))
const AlertsPage = lazy(() => import("../../pages/ees/AlertsPage"))
const TelemetryHealthPage = lazy(() => import("../../pages/ees/TelemetryHealthPage"))
const TelemetryDashboardPage = lazy(() => import("../../pages/ees/TelemetryDashboardPage"))
const IncidentsPage = lazy(() => import("../../pages/ees/IncidentsPage"))
const AuditLogsPage = lazy(() => import("../../pages/ees/AuditLogsPage"))
const ReportsPage = lazy(() => import("../../pages/ees/ReportsPage"))
const RevenuePage = lazy(() => import("../../pages/ees/RevenuePage"))
const ProfilePage = lazy(() => import("../../pages/ees/ProfilePage"))
const UserGuidePage = lazy(() => import("../../pages/ees/UserGuidePage"))
const UserGuideDetailPage = lazy(() => import("../../pages/ees/guide/UserGuideDetailPage"))
const MasterCatalogsPage = lazy(() => import("../../pages/ees/MasterCatalogsPage"))
const ComplianceSettingsPage = lazy(() => import("../../pages/ees/ComplianceSettingsPage"))
const RegulationDetailPage = lazy(() => import("../../pages/ees/RegulationDetailPage"))

function pageList() {
  return [
    { Element: Dashboard, path: "/dashboard", code: "HOME_CONTROLLER" },
    { Element: ProfilePage, path: "/profile", code: "HOME_CONTROLLER" },
    { Element: UserGuidePage, path: "/huong-dan", code: "HOME_CONTROLLER" },
    { Element: UserGuideDetailPage, path: "/huong-dan/:slug", code: "HOME_CONTROLLER" },
    { Element: ProjectsPage, path: "/projects", code: "PROJECT_CONTROLLER" },
    { Element: ProjectsMapPage, path: "/projects/map", code: "PROJECT_CONTROLLER" },
    { Element: ProjectDetailPage, path: "/projects/:id", code: "PROJECT_CONTROLLER" },
    { Element: DailyLogsPage, path: "/daily-logs", code: "OPS_CONTROLLER" },
    { Element: WaterResultsPage, path: "/water-results", code: "OPS_CONTROLLER" },
    { Element: AmmPage, path: "/amm", code: "AMM_CONTROLLER" },
    { Element: AmmEquipmentPage, path: "/amm/thiet-bi", code: "AMM_CONTROLLER" },
    { Element: AmmStockPage, path: "/amm/kho", code: "AMM_CONTROLLER" },
    { Element: AmmProjectStockPage, path: "/amm/kho-du-an", code: "AMM_CONTROLLER" },
    { Element: AmmStocktakePage, path: "/amm/kiem-ke", code: "AMM_CONTROLLER" },
    { Element: AmmIssuePage, path: "/amm/cap-phat", code: "AMM_CONTROLLER" },
    { Element: AmmMaintenancePage, path: "/amm/bao-tri", code: "AMM_CONTROLLER" },
    { Element: AmmSettingsPage, path: "/amm/cai-dat", code: "AMM_CONTROLLER" },
    { Element: AmmReportsPage, path: "/amm/bao-cao", code: "AMM_CONTROLLER" },
    { Element: AlertsPage, path: "/alerts", code: "ALERT_CONTROLLER" },
    { Element: TelemetryHealthPage, path: "/telemetry", code: "TELEMETRY_CONTROLLER" },
    {
      Element: TelemetryDashboardPage,
      path: "/telemetry/dashboard",
      code: "TELEMETRY_DASHBOARD_CONTROLLER"
    },
    { Element: IncidentsPage, path: "/incidents", code: "INCIDENT_CONTROLLER" },
    { Element: AuditLogsPage, path: "/audit-logs", code: "AUDIT_CONTROLLER" },
    { Element: MasterCatalogsPage, path: "/settings/catalogs", code: "SETTINGS_CONTROLLER" },
    { Element: ComplianceSettingsPage, path: "/settings/compliance", code: "SETTINGS_CONTROLLER" },
    { Element: RegulationDetailPage, path: "/settings/compliance/:id", code: "SETTINGS_CONTROLLER" },
    { Element: ReportsPage, path: "/reports", code: "REPORT_CONTROLLER" },
    { Element: RevenuePage, path: "/revenue", code: "REVENUE_CONTROLLER" },
    { Element: Permission, path: "/staff", code: "STAFF_CONTROLLER" },
    { Element: Permission, path: "/staff/:tab", code: "STAFF_CONTROLLER" },
    { Element: PermissionDetail, path: "/staff/groups/:id/:name", code: "STAFF_CONTROLLER" }
  ]
}

export default pageList
